<template>
    <div class="orderdetail">
        <ul class="orderdetail-ul">
            <li class="orderdetail-li" :class="curClick == 0 ? 'li-active' : ''" @click="tabStype(0)">全部订单</li>
            <li class="orderdetail-li" :class="curClick == 1 ? 'li-active' : ''" @click="tabStype(1)">待付款</li>
            <li class="orderdetail-li" :class="curClick == 2 ? 'li-active' : ''" @click="tabStype(2)">待出行</li>
            <li class="orderdetail-li" :class="curClick == 3 ? 'li-active' : ''" @click="tabStype(3)">出行中</li>
            <li class="orderdetail-li" :class="curClick == 4 ? 'li-active' : ''" @click="tabStype(4)">已完成</li>
            <li class="orderdetail-li" :class="curClick == 5 ? 'li-active' : ''" @click="tabStype(5)">退款/售后</li>
        </ul>

        <div class="new-order-list" v-if="orderList.length">
            <div class="new-order-list-area"
                 v-for="(item,index) in orderList.slice((currentPage-1)*pagesize,currentPage*pagesize)"
                 :key="index"
                 @click="toOrderDetail(item.id)"
            >
                <div class="order-list-single-number">
                    <div class="order-number">
                        订单号：{{ item.order_num }}
                    </div>
                    <div class="order-time">
                        下单时间： {{ item.created_at }}
                    </div>
                </div>

                <div class="order-list-single">
                    <img class="order-area-img" :src="item.rotation" alt="">
                    <div class="order-area-box">
                        <div class="order-area-top">
                            <p class="order-area-type">{{ item.title }}</p>
                            <div class="order-area-money">
                                <span class="order-area-money-num">¥ {{ item.paymoney }}</span>
                                |
                                <!--:class="item.statusStyle"-->
                                <span class="order-area-status" :class="item.status == 0 ? 'classZero' : (item.status == 1 ? 'classOne' : (item.status == 2 ? 'classTwo' : 'classThree'))">
                                    {{ item.status == 0 ? '待付款' : (item.status == 1 ? '待出行' : (item.status == 2 ? '出行中' : '已完成')) }}
                                </span>
                            </div>
                        </div>

                        <div class="order-trip">
                            <p class="order-trip-tit">
                                出发城市：
                            </p>
                            <span class="order-trip-start">
                                {{ item.city_name }}
                            </span>
                            <!--<img src="@/assets/images/persondata/personal_icon_dao.png" alt="">-->
                            <!--<span class="order-trip-start">{{ item.end }}</span>-->
                        </div>

                        <div class="order-trip-time">
                            <span class="order-trip-start-time">
                                行程日期：
                            </span>
                            <span class="order-trip-detail-time">
                                <span class="timeStart">{{ item.start_time }}</span>
                                <span class="timeFuhao">~</span>
                                <span class="timeEnd">{{ item.end_time }}</span>
                            </span>
                        </div>

                        <div class="order-trip-car">
                            <span class="order-trip-start-time">
                                出&nbsp;&nbsp;行&nbsp;人：
                            </span>
                            <span class="order-trip-detail-time">
                                {{ item.contact_name }} {{ item.contact_tel }}
                            </span>
                        </div>
                    </div>
                </div>
            </div>

            <el-pagination
                    class="el-pagination-car"
                    @size-change="handleSizeChange"
                    @current-change="currentPageChange"
                    :current-page.sync="currentPage"
                    layout="prev, pager, next, jumper"
                    :page-size="pagesize"
                    :pager-count="5"
                    :total="orderList.length"
            >
            </el-pagination>
        </div>
        <p class="no-more-order" v-else="orderList.length">
            没有更多订单
        </p>
    </div>
</template>

<script>
    export default {
        name: "travelorder",
        data() {
            return {
                curClick: 0,
                orderList: [],
                /*orderList: [
                    {
                        imgUrl: require('@/assets/images/persondata/personal_icon_shouji.png'),
                        type: '市内用车',
                        money: '85255',
                        status: '已完成',
                        start: '出发城市出',
                        end: '出发城市出发城市出发城市',
                        time: '6月4号  9:00',
                        carNum: '9',
                        id: '01'
                    },
                    {
                        imgUrl: require('@/assets/images/persondata/personal_icon_shouji.png'),
                        type: '市内用车',
                        money: '85255',
                        status: '已完成',
                        start: '1222',
                        end: '1222',
                        time: '6月4号  9:00',
                        carNum: '9',
                        id: '02'
                    },
                    {
                        imgUrl: require('@/assets/images/persondata/personal_icon_shouji.png'),
                        type: '市内用车',
                        money: '85255',
                        status: '已完成',
                        start: '出发城市出',
                        end: '出发城市出发城市出发城市',
                        time: '6月4号  9:00',
                        carNum: '9',
                        id: '03'
                    },
                    {
                        imgUrl: require('@/assets/images/persondata/personal_icon_shouji.png'),
                        type: '市内用车',
                        money: '85255',
                        status: '已完成',
                        start: '1222',
                        end: '1222',
                        time: '6月4号  9:00',
                        carNum: '9',
                        id: '04'
                    },
                    {
                        imgUrl: require('@/assets/images/persondata/personal_icon_shouji.png'),
                        type: '市内用车',
                        money: '85255',
                        status: '已完成',
                        start: '出发城市出',
                        end: '出发城市出发城市出发城市',
                        time: '6月4号  9:00',
                        carNum: '9',
                        id: '05'
                    },
                    {
                        imgUrl: require('@/assets/images/persondata/personal_icon_shouji.png'),
                        type: '市内用车',
                        money: '85255',
                        status: '已完成',
                        start: '1222',
                        end: '1222',
                        time: '6月4号  9:00',
                        carNum: '9',
                        id: '06'
                    },
                    {
                        imgUrl: require('@/assets/images/persondata/personal_icon_shouji.png'),
                        type: '市内用车',
                        money: '85255',
                        status: '已完成',
                        start: '出发城市出',
                        end: '出发城市出发城市出发城市',
                        time: '6月4号  9:00',
                        carNum: '9',
                        id: '07'
                    },
                    {
                        imgUrl: require('@/assets/images/persondata/personal_icon_shouji.png'),
                        type: '市内用车',
                        money: '85255',
                        status: '已完成',
                        start: '1222',
                        end: '1222',
                        time: '6月4号  9:00',
                        carNum: '9',
                        id: '081'
                    },
                ],*/
                currentPage: 1,
                pagesize: 6,
            }
        },
        methods: {
            handleSizeChange(val) {
                console.log(`每页 ${val} 条`);
            },
            currentPageChange(val) {
                console.log(`当前页: ${val}`);
            },
            tabStype(idx) {
                this.curClick = idx;
                switch (idx) {
                    case 0:
                        this.gettravelList('','','');
                        break;
                    case 1:
                        this.gettravelList(0,'','');
                        break;
                    case 2:
                        this.gettravelList(1,'','');
                        break;
                    case 3:
                        this.gettravelList(2,'','');
                        break;
                    case 4:
                        this.gettravelList(3,'','');
                        break;
                    case 5:
                        this.gettravelList(4,'','');
                        break;
                    default:
                        break;
                }
            },
            toOrderDetail(id) {
                this.$router.push({name: 'Orderparticularstravel', params: {orderId: id}});
            },
            gettravelList(t_status, page, limit) {
                var that = this;
                const loading = this.$loading({
                    lock: true,
                    text: '数据加载中',
                    spinner: 'el-icon-loading',
                    background: 'rgba(0, 0, 0, 0.7)'
                });
                that.$axios.post('/myTravelOrder', {
                    t_status: t_status,
                    page: page,
                    limit: limit
                }).then((res) => {
                    loading.close();
                    res = res.data;
                    if (res.status == 200) {
                        // console.log(res.data);
                        this.orderList = res.data;
                    } else {
                        // console.log(res);
                        this.$message(res.msg);
                    }
                }).catch((error) => {
                    loading.close();
                    this.$message('系统错误');
                });
            }
        },
        mounted() {
            this.gettravelList('', '', '');
        }
    }
</script>

<style scoped>
    .orderdetail {
        width: 997px;
    }

    .orderdetail-ul {
        width: 997px;
        height: 56px;
        border-bottom: 1px solid #eee;
        display: flex;
        flex-direction: row;
        align-items: center;
    }

    .orderdetail-li {
        min-width: 90px;
        height: 56px;
        line-height: 56px;
        font-size: 16px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #333;
        text-align: center;
        cursor: pointer;
    }

    .li-active {
        position: relative;
        color: #FF5227;
    }

    .li-active:after {
        content: '';
        width: 46px;
        height: 2px;
        background: #FF5227;
        position: absolute;
        left: 50%;
        bottom: 0;
        margin-left: -23px;
    }

    .new-order-list {
        margin-top: 20px;
    }

    .new-order-list-area {
        width: 800px;
        height: 200px;
        border: 1px solid #EEEEEE;
        margin-bottom: 10px;
        cursor: pointer;
    }

    .order-list-single-number {
        width: 100%;
        height: 34px;
        background: #F8F8F8;
        display: flex;
        flex-direction: row;
        align-items: center;
    }

    .order-number, .order-time {
        height: 34px;
        line-height: 34px;
        display: flex;
        flex-direction: row;
        align-items: center;
        margin-left: 24px;
        font-size: 12px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #333333;
    }

    .order-list-single {
        display: flex;
        flex-direction: row;
    }

    .order-area-img {
        width: 150px;
        height: 90px;
        border-radius: 4px;
        margin: 16px 20px 0;
    }

    .order-area-box {
        width: 600px;
        margin-top: 16px;
    }

    .order-area-top {
        width: 100%;
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        margin-top: 5px;
    }

    .order-area-type {
        width: 450px;
        line-height: 24px;
        font-size: 16px;
        font-family: Microsoft YaHei;
        font-weight: bold;
        color: #333333;
    }

    .order-area-money {
        max-width: 150px;
        line-height: 24px;
        display: flex;
        flex-direction: row;
        align-items: center;
    }

    .order-area-money-num {
        color: #CF0000;
        font-size: 16px;
        height: 24px;
        line-height: 24px;
        margin-right: 6px;
    }

    .order-area-status {
        color: #2577E3;
        font-size: 16px;
        height: 24px;
        line-height: 24px;
        margin-left: 6px;
    }

    .classZero {
        color: #CF0000;
    }

    .classOne {
        color: #2577E3;
    }

    .classTwo {
        color: #F75000;
    }

    .classThree {
        color: #9F4D95;
    }
    .order-trip {
        margin-top: 4px;
        display: flex;
        flex-direction: row;
        align-items: center;
    }

    .order-trip-tit {
        font-size: 14px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #666666;
        height: 30px;
        line-height: 30px;
    }

    .order-trip-start {
        min-width: 100px;
        max-width: 240px;
        height: 30px;
        line-height: 30px;
        font-size: 14px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #666;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
    }

    .order-trip img {
        width: 27px;
        height: 6px;
        margin-left: 18px;
        margin-right: 18px;
    }

    .order-trip-time, .order-trip-car {
        height: 24px;
        display: flex;
        flex-direction: row;
        align-items: center;
    }

    .order-trip-start-time {
        width: 70px;
        height: 24px;
        line-height: 24px;
        font-size: 14px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #666666;
    }

    .order-trip-detail-time {
        height: 24px;
        line-height: 24px;
        font-size: 14px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #666666;
    }

    .timeStart {
        font-size: 14px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #666666;
    }

    .timeFuhao {
        margin: 0 10px;
    }

    .timeEnd {
        font-size: 14px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #666666;
    }

    .el-pagination-car {
        width: 100%;
        display: flex;
        flex-direction: row;
        justify-content: center;
        align-items: center;
        margin: 30px 0 48px 0;
    }

    .no-more-order {
        width: 100%;
        height: 20px;
        line-height: 24px;
        font-size: 12px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #999999;
        text-align: center;
        margin-top: 20px;
    }
</style>



// WEBPACK FOOTER //
// src/pages/persondata/children/travelorder.vue